export default {
  computed: {
    holidays() {
      return this.$store.getters.getHolidays
    }
  },
  methods: {
    calculateHolidays(startDate, endDate) {
      let from = new Date(startDate);
      let to = new Date(endDate);
      to.setDate(to.getDate() + 1);

      let counter = 0;

      if (from.getTime() <= to.getTime()) {
        while (
          `${from.getDate()}/${from.getMonth()}/${from.getFullYear()}` !==
          `${to.getDate()}/${to.getMonth()}/${to.getFullYear()}` &&
          counter <= 1000
        ) {
          if (
            from.getDay() !== 0 &&
            from.getDay() !== 6 &&
            this.holidays.indexOf(
              `${from.getDate()}/${from.getMonth() + 1}/${from.getFullYear()}`
            ) === -1
          ) {
            counter++;
          }
          from.setDate(from.getDate() + 1);
        }
      }

      return counter;
    },
  }
}